
import { Button, Collapse, theme } from 'antd';
import { PlusOutlined, DeleteOutlined, CaretRightOutlined, EditOutlined } from '@ant-design/icons';
import Loading from '../../../shared/components/Loading/Index';
import ItemDetail from './ItemDetail';

import './styles.css'

export default function Items(props) {
    const { token } = theme.useToken();

    return (
        <Loading visible={props.loading} text='Un momento por favor.'>
            <Collapse
                bordered={false}
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                className="section-collapse"
                style={{ background: token.colorBgContainer }}
                items={props.sections.map(item => (
                    {
                        key: item.id,
                        label: item.title,
                        children: (
                            <ItemDetail
                                items={item.items}
                                loading={false}
                                onDelete={props.onDeleteDetail}
                                onDragStart={props.onDragStart}
                                onDragEnter={props.onDragEnter}
                                onDragLeave={props.onDragLeave}
                                onDrop={props.onDrop}
                                onDragEnd={props.onDragEnd}
                                onEdit={props.onEditDetail}
                            />
                        ),
                        extra: (
                            <>
                                <Button
                                    type="text"
                                    icon={<PlusOutlined />}
                                    onClick={(event) => props.onAdd(event, item)}
                                />
                                <Button
                                    type="text"
                                    icon={<EditOutlined />}
                                    onClick={(event) => props.onEdit(event, item)}
                                />
                                <Button danger
                                    type="text"
                                    icon={<DeleteOutlined />}
                                    onClick={(event) => props.onDelete(event, item)}
                                />
                            </>
                        )
                    }
                ))}
            />
        </Loading>
    );
};
